module.exports = __webpack_public_path__ + "img/ics_o_chevron_right-red.98017107.svg";